import React from 'react';
import { MessageComposer } from '../components/composer/MessageComposer';
export function Cadencias() {
  return <div className="p-4 md:p-8 max-w-[1100px] mx-auto space-y-6 pb-24 md:pb-8" data-id="element-768">
      <div className="flex items-center justify-between" data-id="element-769">
        <div data-id="element-770">
          <h1 className="text-2xl font-bold text-growthly-black" data-id="element-771">
            Cadencias y Mensajería
          </h1>
          <p className="text-sm text-growthly-medium mt-1" data-id="element-772">
            Envía mensajes usando plantillas optimizadas.
          </p>
        </div>
      </div>

      <MessageComposer data-id="element-773" />
    </div>;
}